import { render, staticRenderFns } from "./CreateBetgame.vue?vue&type=template&id=0f670382&scoped=true"
import script from "./CreateBetgame.vue?vue&type=script&lang=js"
export * from "./CreateBetgame.vue?vue&type=script&lang=js"
import style0 from "./CreateBetgame.vue?vue&type=style&index=0&id=0f670382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f670382",
  null
  
)

export default component.exports